export default "__VITE_ASSET__Cy$SXNDb__"